import React from 'react';

const BarChartLoader = () => {
  const barCount = 6;

  const containerStyle = {
    maxWidth: '2000px',
    margin: '40px auto',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
    fontFamily: 'sans-serif',
  };

  const chartAreaStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-end',
    height: '160px',
    borderLeft: '1px solid #e0e0e0',
    borderBottom: '1px solid #e0e0e0',
    padding: '0 10px',
    position: 'relative',
    backgroundColor: '#fafafa',
  };

  const barWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '12%',
  };

  const getBarStyle = (heightPercent) => ({
    width: '24px',
    height: heightPercent,
    backgroundColor: '#d6e4f0',
    borderRadius: '4px 4px 0 0',
    animation: 'pulse 1.5s infinite ease-in-out',
  });

  const xLabelStyle = {
    height: '12px',
    width: '30px',
    backgroundColor: '#e0e0e0',
    marginTop: '10px',
    borderRadius: '4px',
    animation: 'pulse 1.5s infinite ease-in-out',
  };

  const titleBarStyle = {
    height: '18px',
    width: '180px',
    backgroundColor: '#e0e0e0',
    borderRadius: '6px',
    marginBottom: '20px',
    animation: 'pulse 1.5s infinite ease-in-out',
  };

  return (
    <div style={containerStyle}>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
          }
        `}
      </style>

      {/* Title Placeholder */}
      <div style={titleBarStyle}></div>

      {/* Chart Area */}
      <div style={chartAreaStyle}>
        {Array.from({ length: barCount }).map((_, i) => (
          <div key={i} style={barWrapperStyle}>
            <div
              style={getBarStyle(`${Math.floor(Math.random() * 50 + 30)}%`)}
            ></div>
            <div style={xLabelStyle}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BarChartLoader;
